import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { CameraConstants } from "../../Constants/CameraConstants";
import { GameEventsConstants } from "../../Constants/GameEventsConstants";
import { PlayerTurnConstant } from "../../Constants/PlayerTurnConstant";
import { HIT_FOR_TURN } from "../../Constants/RulesCommonConstants";
import { CameraHelpers } from "../../Helpers/Helpers";
import { LocalizationContents } from "../../LocalizationContents";
import { GameLogic } from "../../Logic/GameLogic";
import { DropDownScoreLog, GameModel, IScoreLogItem } from "../../Models/GameModel";
import { AnimationContents } from "../AnimationContents";
import { DropdownController, IDropdownControllerOptions } from "./DropDownController";
import {KyykasContainerController} from "./KyykasContainerController";

export class MiniMapController extends AnimationBaseController {
    $model: GameModel;


    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super("MiniMapController");
        console.log('MiniMapController', this);

    }

    protected getConfiguration(): IAnimationControllerConfiguration {

        return {
            animationContent: AnimationContents.TABLO_SCREEN_JSON,
            libraryName: 'KK_board',
            childControllers: {
                Dropdown: {
                    instanceName: 'dropdown_menu',
                    view: DropdownController,
                    model: this.$model,
                    options: <IDropdownControllerOptions> {
                        onOpen: () => {
                            this.$childControllers.get <DropdownController>('Dropdown').open();
                        },
                        onClose: () => {
                            this.$childControllers.get <DropdownController>('Dropdown').close();
                        }
                    }
                },
                KyykasContainer: {
                    instanceName: 'kykkas_container',
                    view: KyykasContainerController,
                    model: this.$model
                }
            },
            modelWatch: {
                isFreeField: (isFreeField: boolean) => {
                    if (isFreeField) {
                        this.$childControllers.get<DropdownController>('Dropdown').setData([
                            {list: [], complete: false }
                        ]);
                    }
                },
                cameraIndex: (cameraIndex: CameraConstants) => {
                    this.visible = !CameraHelpers.isCameraZoomed(cameraIndex);
                },
                isGameReady: (ready: boolean) => {
                    if (ready) {
                        this._setIndicatorByState();
                    }
                },
                lang: () => {
                    this._setIndicatorByState();
                    this._setScores(this.$model.scoresLog);
                }
            },
            modelEvents: {
                [GameEventsConstants.updateScores]: () => {
                    this._setScores(this.$model.scoresLog);
                    this._setIndicatorByState();
                }
            }
        };
    }

    protected onInitialize(): void {
        const scale = 0.65;
        this.scaleX = scale;
        this.scaleY = scale;
        this._setIndicatorByState();
        this._setScores(this.$model.scoresLog);
    }

    protected onResize(width: number, height: number, scale: number): void {
        this.x = width / scale / 2;
        this.y = -height / scale / 2;
    }

    private _setIndicatorByState() {
        // синяя и красная лампочка
        this.gotoAndStopByQuery('red', this.$model.currentTurn === PlayerTurnConstant.A ? 'on' : 'off');
        this.gotoAndStopByQuery('blue', this.$model.currentTurn === PlayerTurnConstant.B ? 'on' : 'off');

        this.updateLocale();
    }




    private _setScores(scoresLog: DropDownScoreLog[]) {
        this.setTextByQuery(`score_a.text`, this.$model.playerA.scores.toString());
        this.setTextByQuery(`score_b.text`, this.$model.playerB.scores.toString());
        this.$childControllers.get<DropdownController>('Dropdown').setData(scoresLog);
    }

    updateLocale() {
        // заголовок с номером хода
        const moveCount = Math.floor((this.$model.playerA.hits + this.$model.playerB.hits)) + 1;
        const str = LocalizationContents.getText("tablo_move_number")
            .replace('{{string}}', moveCount.toString());
        this.setTextByQuery('title_move.title_text', str.toUpperCase());
    }

}